
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"id-31a"}},[_c('path',{attrs:{"d":"M15 0a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14zm-5 2a4 4 0 100 8 4 4 0 000-8zM4 8.5H2l-.09.008A.5.5 0 002 9.5h2l.09-.008A.5.5 0 004 8.5zM10 3a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2zm-6 .5H2l-.09.008A.5.5 0 002 6.5h2l.09-.008A.5.5 0 004 5.5zm0-3H2l-.09.008A.5.5 0 002 3.5h2l.09-.008A.5.5 0 004 2.5z"}})])]),_c('g',{attrs:{"clip-path":"url(#id-31a)","transform":"translate(4 6)"}},[_c('path',{attrs:{"fill":"#FFF","d":"M0 0h16v12H0V0z"}})])])
          )
        }
      }
    